(() => {
  if (window.__ccNextSectionNavLoaded) return;
  window.__ccNextSectionNavLoaded = true;

  const selector = '[data-cc-next-section-nav]';
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getHeaderOffset = () => {
    const bodyStyles = getComputedStyle(document.body);
    const cssHeaderHeight = Number.parseFloat(bodyStyles.getPropertyValue('--header-group-height')) || 0;
    const headerGroupHeight = document.querySelector('#header-group')?.getBoundingClientRect().height || 0;
    const headerOffset = Math.max(cssHeaderHeight, headerGroupHeight);

    return Math.min(headerOffset + 12, Math.max(0, window.innerHeight - 80));
  };

  const init = (component) => {
    if (component.dataset.initialized === 'true') return;

    const button = component.querySelector('button');
    const main = component.closest('#MainContent') || document.querySelector('#MainContent');
    const ownSection = component.closest('.shopify-section');

    if (!button || !main) return;

    component.dataset.initialized = 'true';
    let nextSection = null;
    let refreshFrame = null;

    const getMajorSections = () =>
      Array.from(main.children).filter((element) => {
        if (!(element instanceof HTMLElement) || !element.classList.contains('shopify-section')) return false;
        if (element === ownSection || element.querySelector(selector)) return false;
        return element.getBoundingClientRect().height > 80;
      });

    const refresh = () => {
      const viewportTop = window.scrollY + getHeaderOffset() + 12;
      nextSection =
        getMajorSections().find((section) => section.getBoundingClientRect().top + window.scrollY > viewportTop) || null;

      const isVisible = Boolean(nextSection);
      component.dataset.state = isVisible ? 'visible' : 'hidden';
      component.setAttribute('aria-hidden', String(!isVisible));
      button.disabled = !isVisible;
      button.tabIndex = isVisible ? 0 : -1;

      if (!isVisible && document.activeElement === button) button.blur();

      if (nextSection?.id) {
        button.setAttribute('aria-controls', nextSection.id);
      } else {
        button.removeAttribute('aria-controls');
      }
    };

    const scheduleRefresh = () => {
      if (refreshFrame !== null) return;

      refreshFrame = window.requestAnimationFrame(() => {
        refreshFrame = null;
        refresh();
      });
    };

    button.addEventListener('click', () => {
      refresh();
      if (!nextSection) return;

      const top = Math.max(
        0,
        nextSection.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 8
      );

      window.scrollTo({
        top,
        behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
      });
    });

    window.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener('resize', scheduleRefresh);
    reducedMotionQuery.addEventListener?.('change', scheduleRefresh);

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(scheduleRefresh);
      resizeObserver.observe(main);
      component.resizeObserver = resizeObserver;
    }

    refresh();
  };

  const initAll = (root = document) => {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll?.(selector).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initAll(event.target);
  });
})();
